var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showDetail)?_c('b-container',{staticClass:"main-content-container px-4 pb-4",attrs:{"fluid":""}},[(_vm.$userCan(['administrator', 'dealer','distributor','subdealer']))?_c('b-card',[_c('Price')],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }